// src/hooks/paxTypes/useDeletePaxTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deletePaxType } from "../../api/apiPaxTypes";
import parseError from "../../utils/parseError";

const useDeletePaxTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: deletePaxTypes, isPending: isDelete } = useMutation({
        mutationFn: deletePaxType,
        onSuccess: (res) => {
            const message = res?.message || "Pax type deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete pax type");
        },
    });

    return { deletePaxTypes, isDelete };
};

export default useDeletePaxTypes;